module.exports = __webpack_public_path__ + "img/treatments-directory-dashboard-mobile-en.78abf9f3.jpg";